import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';

@Component({
  selector: 'ish-product-quantity-label',
  templateUrl: './product-quantity-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
})
export class ProductQuantityLabelComponent implements OnInit {
  private context = inject(ProductContextFacade);

  readonly for = input('');
  readonly translationKey = input('product.quantity.label');

  visible$: Observable<boolean>;

  ngOnInit() {
    this.visible$ = this.context.select('displayProperties', 'quantity');
  }
}
